import { avisoDoEmbutido, type ConfigSubsistemas, type LinkExterno } from '@malgoos/shared';
import { MENUS } from '../nucleo/menus';
import { destinoDoMenu, modulosDoMenu, modulosWeb, paginasDoSubsistema, type Acesso } from '../nucleo/modulos-web';

/** CRM no novo desenho, Fase 1: regras puras da casca nova (`CascaNova.tsx`), testadas em `tests/crm-f1-casca-nova.test.ts`. */

/** Menu de entrada de cada sub-sistema (o clone abre o CRM no Comercial); sem ele, o primeiro menu com página. */
export const ENTRADA_DO_SUBSISTEMA: Record<string, string> = { adm: 'cadastros', crm: 'comercial', erp: 'financeiro', rh: 'pessoas', suporte: 'operacao', automacoes: 'automacoes' };

/**
 * Primeira página do sub-sistema (fora o Início): o destino ao trocar pelo seletor. A página própria da casca vem antes do menu.
 * `cfg` (val8): a configuração efetiva, que diz em que sub-sistemas fica cada página da casca (vazia: a divisão padrão).
 */
export function primeiroDestino(acesso: Acesso, naNavegacao: (slug: string, aba: string) => boolean, sub?: string, cfg: ConfigSubsistemas = {}): string {
  const [propria] = paginasDoSubsistema(acesso, sub ?? null, modulosWeb, cfg);
  if (propria) return `/${propria.pagina.caminho}`;
  const filtrado: Acesso = { ...acesso, naNavegacao };
  const entrada = sub ? ENTRADA_DO_SUBSISTEMA[sub] : undefined;
  const preferido = entrada && modulosDoMenu(entrada, filtrado).length ? destinoDoMenu(entrada, filtrado) : null;
  if (preferido) return preferido;
  for (const m of MENUS) {
    if (m.chave === 'inicio' || !modulosDoMenu(m.chave, filtrado).length) continue;
    const destino = destinoDoMenu(m.chave, filtrado);
    if (destino) return destino;
  }
  return '/';
}

/** Link externo do Cofre de senhas (o aviso `cofre` do host embutível), se a pessoa o vê. */
export const linkDoCofre = (links: LinkExterno[]) => links.find((l) => avisoDoEmbutido(l.url) === 'cofre') ?? null;
